
import { computed, defineComponent, ref } from 'vue'

const TABS = [
    { id: 'today', label: 'Сегодня' },
    { id: 'tomorrow', label: 'Завтра' },
] as const

const PREVIEW_DATA = {
    today: {
        label: 'Сегодня, 27 июля',
        count: '3 свободных окна',
        potential: '12 900 ₽',
        task: 'Перенести запись на сегодня',
        badge: 'Завтра → сегодня',
        candidate: 'Артём Волков',
        meta: 'Записан завтра в 11:00 к Дмитрию',
        score: '96%',
        from: 'Завтра, 11:00',
        to: 'Сегодня, 10:30',
        windows: [
            { time: '10:30', service: 'Мужская стрижка', price: '1 700 ₽' },
            { time: '14:00', service: 'Маникюр с покрытием', price: '2 400 ₽' },
            { time: '18:30', service: 'Окрашивание', price: '8 800 ₽' },
        ],
    },
    tomorrow: {
        label: 'Завтра, 28 июля',
        count: '4 свободных окна',
        potential: '19 600 ₽',
        task: 'Записать клиента без будущей записи',
        badge: 'Без будущей записи',
        candidate: 'Марина Соколова',
        meta: 'Цикл просрочен, утром ходит чаще всего',
        score: '97%',
        from: 'Нет будущей записи',
        to: 'Завтра, 09:00',
        windows: [
            { time: '09:00', service: 'Стрижка + укладка', price: '3 200 ₽' },
            { time: '12:30', service: 'Маникюр с покрытием', price: '2 400 ₽' },
            { time: '16:00', service: 'Стрижка + борода', price: '2 600 ₽' },
            { time: '19:00', service: 'Тонирование', price: '6 200 ₽' },
        ],
    },
} as const

export default defineComponent({
    name: 'HotWindowsPreview',
    setup() {
        const activeDay = ref<(typeof TABS)[number]['id']>('today')
        const day = computed(() => PREVIEW_DATA[activeDay.value])

        return {
            tabs: TABS,
            activeDay,
            day,
        }
    },
})
